import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FilterParams } from "../models/filterParams";
import { FormGroup } from "@angular/forms";
import { take } from "rxjs";
import { Location } from "@angular/common";

@Injectable({ providedIn: "root" })
export class FiltersService {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {}

  updateMultipleQueryFilters(updatedFilters: Record<string, any>) {
    this.route.queryParams.pipe(take(1)).subscribe((params) => {
      let filters: any = {};

      if (params["filters"]) {
        filters = JSON.parse(decodeURIComponent(params["filters"]));
      }
      const mergedFilters = {
        ...filters,
        ...updatedFilters,
      };

      const cleanedFilters: Record<string, any> = {};
      for (const key in mergedFilters) {
        const value = mergedFilters[key];
        const isEmptyArray =
          Array.isArray(value) && value.every((v) => v === null || v === "");
        const isEmptyObject =
          typeof value === "object" &&
          !Array.isArray(value) &&
          value !== null &&
          Object.keys(value).length === 0;

        if (value !== null && value !== "" && !isEmptyArray && !isEmptyObject) {
          cleanedFilters[key] = value;
        }
      }
      const jsonFilters = JSON.stringify(cleanedFilters);

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          filters: jsonFilters,
        },
        queryParamsHandling: "merge",
      });
    });
  }

  decodeUri(): FilterParams | null {
    let filters: FilterParams | null = null;
    this.route.queryParams.subscribe((params) => {
      if (params["filters"]) {
        filters = JSON.parse(decodeURIComponent(params["filters"]));
      }
    });
    return filters;
  }

  patchFormValue(
    filters: FilterParams | null,
    keys: (keyof FilterParams)[],
    formFilter: FormGroup | null
  ): FormGroup | null {
    if (!filters || !formFilter) return formFilter;

    // Temporary object with keys from FilterParams used to patch the form values
    const patch: Partial<Record<keyof FilterParams, any>> = {};

    keys.forEach((key) => {
      if (filters[key] !== undefined) {
        patch[key] = filters[key];
      }
    });

    formFilter.patchValue(patch);
    return formFilter;
  }

  extractValueFromUrl(
    filters: FilterParams | null,
    key: keyof FilterParams,
    defaultValue: any
  ): any {
    if (filters && filters.hasOwnProperty(key)) {
      return filters[key];
    }
    return defaultValue;
  }

  extractArrayValueFromUrl(
    filters: FilterParams | null,
    key: keyof FilterParams,
    defaultValue: string[]
  ): string[] {
    if (filters && filters[key] !== undefined) {
      const result = filters[key];
      if (Array.isArray(result)) {
        return result as string[];
      }
    }
    return defaultValue;
  }
}
